import { color, media, radius, spacing, typography } from '@gyym/ui'
import styled, { css } from 'styled-components'

export const MapContainer = styled.div`
  position: relative;
  height: 100%;
`

interface FacilityCardContainerProps {
  iframeForceViewMode?: 'pc' | 'sp' | 'simple-embed'
}

export const FacilityCardInner = styled.div`
  display: flex;
  align-items: center;

  & > a {
    pointer-events: all;
    min-width: 330px;
    max-width: 366px;

    ${media.tablet} {
      min-width: 366px;
      width: 366px;
    }

    &:not(:first-child) {
      margin-left: ${spacing(2)};
    }
  }
`

const getIFrameCss = ({ iframeForceViewMode }: FacilityCardContainerProps) =>
  iframeForceViewMode
    ? iframeForceViewMode === 'sp'
      ? css`
          bottom: 120px;

          ${FacilityCardInner} {
            padding: 0 ${spacing(4)};
          }

          ${media.tablet} {
            bottom: 120px;

            ${FacilityCardInner} {
              padding: 0 ${spacing(4)};
            }
          }
        `
      : css`
          bottom: 24px;

          ${FacilityCardInner} {
            padding: 0 ${spacing(6)};
          }

          ${media.tablet} {
            bottom: 24px;

            ${FacilityCardInner} {
              padding: 0 ${spacing(6)};
            }
          }
        `
    : null

export const FacilityCardContainer = styled.div<FacilityCardContainerProps>`
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  user-select: none;
  /* pointer-events: none; */
  overflow-x: scroll;
  max-width: 100vw;
  bottom: 120px;

  ${FacilityCardInner} {
    padding: 0 ${spacing(4)};
  }

  ${media.pc} {
    bottom: 24px;

    ${FacilityCardInner} {
      padding: 0 ${spacing(6)};
    }
  }

  ${getIFrameCss}

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  /* Webkit */
  &::-webkit-scrollbar {
    display: none;
  }
`

export const GpsButton = styled.button`
  position: absolute;
  width: 40px;
  height: 40px;
  right: ${spacing(4)};
  top: ${spacing(8)};
  background: ${color('white')};
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 9px;
  color: ${color('blue.01')};
  cursor: pointer;
  transition: color 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: ${color('red.01')};
  }

  & > svg {
    min-width: 24px;
  }
`

export const IconWrapper = styled.div<{ indicator?: boolean }>`
  position: relative;
  height: 24px;
  width: 24px;
  margin-right: ${spacing(2)};

  ${({ indicator }) =>
    indicator &&
    css`
      &::after {
        content: '';
        width: 12px;
        height: 12px;
        border-radius: ${radius('full')};
        position: absolute;
        top: -1px;
        right: -2px;
        background: ${color('red.01')};
      }
    `}
`

export const ButtonItem = styled.button`
  ${typography('button1')}
  background: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${color('blue.01')};
  white-space: nowrap;
  position: relative;
  padding: 0;

  &:first-child {
    &::after {
      content: '';
      border-left: 1px solid ${color('blue.01')};
      position: absolute;
      height: 22px;
      width: 0;
      right: 0;
    }
  }
`

export const ButtonGroup = styled.div`
  border: 1px solid ${color('blue.01')};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 10;
  display: sticky;
  background: ${color('white')};
  margin: 0 auto;
  width: 100%;
  border-radius: ${radius('full')};
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.12);
  bottom: 40px;
  height: 58px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);

  max-width: 300px;

  @media (min-width: 360px) {
    max-width: 350px;
  }
`
